import { h } from 'preact';
import styles from './ProductCard.module.scss';
export function SkeletonCard() {
    return (h("div", { class: styles.skeletonCard },
        h("div", { class: styles.skeletonImage }),
        h("div", { class: styles.skeletonInfo },
            h("div", { class: styles.skeletonBrand }),
            h("div", { class: styles.skeletonTitle }),
            h("div", { class: styles.skeletonTitle }),
            h("div", { class: styles.skeletonPrice }))));
}
